import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';
import competentProfessionalsService from '../../services/company/competent_professional.service';
import competentProfessionalsTemplateService from '../../services/company/competent_professionals_template.service';
import CompetentProfessionalImportModal from './CompetentProfessionalImportModal';
import { useParams, useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { Loader } from '@rd-web-markets/shared/dist/util/Loader';
import CompetentProfessionalTable from './CompetentProfessionalTable';
import { CloudUploadButton } from '@rd-web-markets/shared/dist/util/buttons/CloudUploadButton';
import { CloudDownloadButton } from '@rd-web-markets/shared/dist/util/buttons/CloudDownloadButton';
import BackgroundJobStatusDisplay from '@rd-web-markets/shared/dist/jobs/BackgroundJobStatusDisplay';
import PaginationMain from '@rd-web-markets/shared/dist/util/pagination/PaginationMain';
import { parseQueryString, buildQueryString } from '@rd-web-markets/shared/dist/services/service';
export default function CompetentProfessionalTab(_ref) {
  let {
    eventKey
  } = _ref;
  const {
    id: companyId
  } = useParams();
  const history = useHistory();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const initialParams = parseQueryString(location.search);
  const [sortConfig, setSortConfig] = useState({
    key: initialParams.sort_by || 'name',
    order: initialParams.sort_order || 'asc'
  });
  const {
    t
  } = useTranslation();
  const [importStatus, setImportStatus, getImportStatus, fetchImportStatusInterval, importcompetentProfessionalsTemplate, exportcompetentProfessionalsTemplate] = competentProfessionalsTemplateService.useImport({
    companyId,
    setLoading
  });
  const {
    competentProfessionals,
    setcompetentProfessionals,
    fetchAllcompetentProfessionals,
    updatecompetentProfessional,
    createcompetentProfessional,
    competentProfessionalsTotalPages
  } = competentProfessionalsService.useCrud(companyId, setLoading, eventKey === 'competent_professional');
  const sortCompetentProfessionalsByKey = (index, order, key) => {
    const newOrder = sortConfig.key === key && sortConfig.order === 'asc' ? 'desc' : 'asc';
    setSortConfig({
      key,
      order: newOrder
    });
    const currentParams = parseQueryString(location.search);
    const newParams = {
      ...currentParams,
      sort_by: key,
      sort_order: newOrder
    };
    const queryString = buildQueryString(newParams);
    history.replace({
      pathname: location.pathname,
      search: queryString ? `?${queryString}` : ''
    });
    fetchAllcompetentProfessionals(newParams);
  };
  const handleFilter = (headers, queryString) => {
    console.log('Filter called with queryString:', queryString);
    const currentParams = parseQueryString(location.search);
    const newParams = {
      ...currentParams,
      query: queryString
    };
    if (!queryString) {
      delete newParams.query;
    }
    console.log('New params:', newParams);
    const newQueryString = buildQueryString(newParams);
    history.replace({
      pathname: location.pathname,
      search: newQueryString ? `?${newQueryString}` : ''
    });
    fetchAllcompetentProfessionals(newParams);
  };
  const headers = [{
    text: t('name'),
    key: 'name',
    sortable: true,
    filterableByText: true,
    filterBy: 'name',
    order: sortConfig.key === 'name' ? sortConfig.order : null
  }, {
    text: t('qualifications'),
    key: 'qualifications',
    sortable: true,
    filterableByText: true,
    filterBy: 'qualifications',
    order: sortConfig.key === 'qualifications' ? sortConfig.order : null
  }, {
    text: t('relevant_experience'),
    key: 'relevant_experience',
    sortable: true,
    filterableByText: true,
    filterBy: 'relevant_experience',
    order: sortConfig.key === 'relevant_experience' ? sortConfig.order : null
  }, {
    text: t('email'),
    key: 'email',
    sortable: true,
    filterableByText: true,
    filterBy: 'email',
    order: sortConfig.key === 'email' ? sortConfig.order : null
  }, {
    text: t('telephone'),
    key: 'phone',
    sortable: true,
    filterableByText: true,
    filterBy: 'phone',
    order: sortConfig.key === 'phone' ? sortConfig.order : null
  }, {
    text: t('has_advance_access'),
    key: 'has_advance_access',
    sortable: true,
    filterableBySelect: true,
    filterBy: 'has_advance_access',
    filterOptions: ['yes', 'no'],
    order: sortConfig.key === 'has_advance_access' ? sortConfig.order : null
  }];
  if (importStatus?.import_status === 'pending' && fetchImportStatusInterval?.started == false) {
    fetchImportStatusInterval.start();
  } else if (importStatus?.import_status !== 'pending' && fetchImportStatusInterval?.started) {
    fetchImportStatusInterval.clear();
    const currentParams = parseQueryString(location.search);
    fetchAllcompetentProfessionals(currentParams);
  }
  const buildImportErrorTableRow = (importError, index) => {
    return {
      key: index,
      columns: [importError.message, importError.details]
    };
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, showImportModal && /*#__PURE__*/React.createElement(CompetentProfessionalImportModal, {
    show: showImportModal,
    onHide: () => setShowImportModal(false),
    importTemplate: importcompetentProfessionalsTemplate
  }), /*#__PURE__*/React.createElement(Row, {
    className: "mt-4 mb-3 justify-content-center"
  }, /*#__PURE__*/React.createElement(Col, {
    xs: {
      offset: 2,
      span: 4
    }
  }, /*#__PURE__*/React.createElement(CloudUploadButton, {
    disabled: loading,
    loading: loading,
    onClick: () => setShowImportModal(true),
    text: t('import_competentProfessional_confidential'),
    style: {
      width: '100%',
      height: '50px'
    }
  })), /*#__PURE__*/React.createElement(Col, {
    xs: {
      span: 4
    }
  }, /*#__PURE__*/React.createElement(CloudDownloadButton, {
    disabled: loading,
    loading: loading,
    onClick: exportcompetentProfessionalsTemplate,
    text: t('export_competentProfessional_confidential'),
    style: {
      width: '100%',
      height: '50px'
    }
  })), /*#__PURE__*/React.createElement(Col, {
    xs: {
      span: 2
    }
  })), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    className: "d-flex justify-content-center mt-2 mb-4"
  }, /*#__PURE__*/React.createElement(BackgroundJobStatusDisplay, {
    buildErrorTableRowFn: buildImportErrorTableRow,
    jobStatusObject: importStatus,
    errorsArrayPropertyName: "import_messages"
  }))), loading && /*#__PURE__*/React.createElement(Loader, null), !loading && /*#__PURE__*/React.createElement(CompetentProfessionalTable, {
    competentProfessionals: competentProfessionals,
    setcompetentProfessionals: setcompetentProfessionals,
    createcompetentProfessional: createcompetentProfessional,
    updatecompetentProfessional: updatecompetentProfessional,
    onSort: sortCompetentProfessionalsByKey,
    onFilter: handleFilter,
    headers: headers
  }), eventKey === 'competent_professional' && /*#__PURE__*/React.createElement(PaginationMain, {
    totalPages: competentProfessionalsTotalPages
  }));
}